/* eslint-disable @typescript-eslint/no-explicit-any */
export class ArrayUtils {
  /**
   * Method will check if the provided array
   * is empty
   */
  static isEmpty(array: unknown[]): boolean {
    return array === undefined || array === null || !Array.isArray(array) || array.length <= 0;
  }

  static flatten(array: any[], depth = 1): any[] {
    if (ArrayUtils.isEmpty(array)) {
      return array;
    }

    // If depth is 0, return the array as-is
    if (depth < 1) {
      return array.slice();
    }

    // Otherwise, concatenate into the parent array
    return array.reduce((acc, val) => acc.concat(Array.isArray(val) ? ArrayUtils.flatten(val, depth - 1) : val), []);
  }

  static getNumberArray(num = 5) {
    return [...Array(num).keys()];
  }

  static getValueByDotSeparatedKey(key: string, data: object) {
    return key && data ? key.split('.').reduce((o: any, i: string) => o[`${i}`], data) : key;
  }

  static groupBy(array: any[], propName: string) {
    if (ArrayUtils.isEmpty(array)) {
      return {};
    }
    return array.reduce((previousValue: any, currentValue: any) => {
      const curVal = ArrayUtils.getValueByDotSeparatedKey(propName, currentValue);
      previousValue[`${curVal}`] = (previousValue[`${curVal}`] || []) as any[];
      previousValue[`${curVal}`].push(currentValue);
      return previousValue;
    }, {});
  }

  static sortBy(array: any, propName: string) {
    if (ArrayUtils.isEmpty(array)) {
      return [];
    }
    return array.sort((a: any, b: any) => a[`${propName}`].localeCompare(b.pdf_name));
  }

  static uniqueArray(list: any[] = []) {
    return [...new Set(list.map(x => JSON.stringify(x)))].map(y => JSON.parse(y));
  }
}
